import React from 'react';

const CustomSendButtonSVG = ({ onClick }) => (
  <button aria-label="Send" onClick={onClick}>
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M28 55C42.9117 55 55 42.9117 55 28C55 13.0883 42.9117 1 28 1C13.0883 1 1 13.0883 1 28C1 42.9117 13.0883 55 28 55Z" stroke="#111F50"/>
        <path d="M28 14.6055V43.082" stroke="#111F50" strokeWidth="2" strokeLinecap="square"/>
        <path d="M16.1875 24.625L28 12.8125L39.8125 24.625" stroke="#111F50" strokeWidth="2"/>
        <path d="M28 1C13.0883 1 1 13.0883 1 28C1 42.9117 13.0883 55 28 55C42.9117 55 55 42.9117 55 28C55 13.0883 42.9117 1 28 1Z" stroke="#111F50" strokeWidth="2"/>

    </svg>
  </button>
);

export default CustomSendButtonSVG;
